type Listener = (payload: any) => void;

class EventEmitter {
  private events: { [key: string]: Listener[] } = {};

  addListener(event: string, listener: Listener): void {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
  }

  emit(event: string, payload: any): void {
    if (!this.events[event]) {
      return;
    }
    this.events[event].forEach(listener => listener(payload));
  }

  removeAllListener(): void {
    this.events = {};
  }
}

export default EventEmitter;